import { Injectable } from '@angular/core';
import { contentConfigFetched, InjectConfig, IqConfigKey } from '@ddt-web/config-layer';
import { ApiService } from '@ddt-web/data-service';
import { fundPreferenceChildMissingPerms, fundPreferenceMissingPerms } from '@ddt-web/fund-preferences';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, switchMap, tap } from 'rxjs/operators';

import { FundTagData } from '../models';
import { FundTagStoreService } from '../services/fund-tag-store.service';
import { FundTagService } from '../services/fund-tag.service';

@Injectable()
export class FundTagEffects {
	@InjectConfig(IqConfigKey.ENABLE_FUND_TAGS) private readonly enableFundTags = true;

	constructor(
		private actions$: Actions,
		private fundTagService: FundTagService,
		private fundTagStoreService: FundTagStoreService,
		private apiService: ApiService
	) { }

	public fetchAllFundTags$ = createEffect(() =>
		this.actions$.pipe(
			ofType(contentConfigFetched),
			filter(() => this.enableFundTags),
			switchMap(() => this.fundTagService.getAllFundTags()),
			tap((fundTags: FundTagData[]) => {
				this.fundTagStoreService.setFundTags(fundTags);
			})
		), { dispatch: false }
	);

	public applyMissingWudPermsToChildren$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fundPreferenceChildMissingPerms),
			map(action => action.payload),
			filter(payload => payload.store === 'fundTags'),
			switchMap((payload: {
				store: string;
				childrenMissingWudPerms: Set<string>;
				fundPreferences: any[];
			}) => {
				const fundPreferencesById = payload.fundPreferences.reduce((fundPreferencesById, child) => {
					if (payload.childrenMissingWudPerms.has(child.id)) {
						fundPreferencesById[child.id] = child;
					}
					return fundPreferencesById;
				}, {});

				return this.fundTagService.editPreferences(fundPreferencesById, fundPreferencesById, payload.store);
			})
		), { dispatch: false }
	);

	public applyMissingWudPermsToParent$ = createEffect(() =>
		this.actions$.pipe(
			ofType(fundPreferenceMissingPerms),
			map(action => action.payload),
			filter(payload => payload.store === 'fundTags'),
			switchMap(() => {
				return this.apiService.addPreference({
					preferenceKey: 'BFA_FUND_TAGS',
					type: 'PREFERENCE',
					applications: ['BFA']
				});
			})
		), { dispatch: false }
	);
}
